import { newFetchEventStream, newReFetchEventStream } from 'utils/globalApiServices';

/** This function is responsible for processing the real-time response (streaming) from the endpoint. */
export async function askQuestionListenStreamEvents({
  isFirstMessage,
  client_id,
  prompt,
  onMessage, // callback that is called for each fragment received.
  onError, //callback for errors
  onComplete, //callback when the stream ends.
  onLoading, // callback when it finishes making the request and starts receiving fragments
  onSaveConversationID, //callback to update the id of the question context
  conversation_id,
}) {
  const user = JSON.parse(localStorage.getItem('userInfo'))['user'];
  const body = {
    client_id,
    user_id: user?.uuid,
    prompt,
  };

  try {
    const response = await newFetchEventStream({
      firstMessage: isFirstMessage,
      body,
      conversation_id,
    }); //makes the HTTP request

    const header = response.headers.get('X-Conversation-Id');

    const reader = response.body.getReader(); //Allows to read chuck by chuck(fragment)
    const decoder = new TextDecoder('utf-8'); //converts bytes to text.
    let buffer = ''; //accumulates partial text until it can be split correctly.
    let firstChunkReceived = false;

    while (true) {
      //Infinite loop that reads the stream until done is true (end of stream).
      const { done, value } = await reader.read(); //value is a Uint8Array with the data.
      if (done) break;

      buffer += decoder.decode(value, { stream: true }); //The chunk is decoded and added to the buffer.

      const lines = buffer.split('\n'); //Then it is divided by lines
      buffer = lines.pop() || ''; //The last line may be incomplete. It will be saved for the next cycle.

      for (const line of lines) {
        //Every line of the stream is checked.
        const lineStream = line.trim();

        if (lineStream.includes('Error:')) {
          //Error sent directly from backend
          await reader.cancel();
          onError?.();
          onLoading?.();
          return;
        }

        if (lineStream.startsWith('event:')) {
          const data = lineStream.slice(6).trim();
          if (data === 'done') {
            //finish connection
            await reader.cancel();
            if (header && conversation_id === '') onSaveConversationID(header);

            onComplete?.();
            onLoading?.();
            return;
          }
        }

        if (lineStream.startsWith('data:')) {
          //Only those that begin with "data:"" will be processed::
          const data = lineStream.slice(5).trim(); //remove "data:" and spaces

          if (data === '{"success": true}') {
            //Improve
            //finish connection
            await reader.cancel();
            if (header && conversation_id === '') onSaveConversationID(header);
            onComplete?.();
            onLoading?.();
            return;
          }

          if (firstChunkReceived) {
            onLoading?.(); // apagar loader
            firstChunkReceived = false;
          }

          onMessage(data);
          continue;
        }
      }
    }
  } catch (err) {
    //If there is a general error (network, parding, etc.) call onError
    if (onError) {
      onError(err);
      onLoading?.();
    }
  }
}

/** This function is responsible for processing the real-time response (streaming) from the regenerate response endpoint. */
export async function regenerateQuestionListenStreamEvents({
  client_id,
  onMessage, // callback that is called for each fragment received.
  onError, //callback for errors
  onComplete, //callback when the stream ends.
  onLoading, // callback when it finishes making the request and starts receiving fragments
  conversation_id,
  message_id, 
  regenerate_type, 
  reason,
  onStart, // callback when the request ends
}) {

  const body = {
    client_id,
    regenerate_type,
    ...(reason && { reason }),
  };

  try {
    const response = await newReFetchEventStream({
      conversation_id,
      message_id,
      body,
    }); //makes the HTTP request

    const reader = response.body.getReader(); //Allows to read chuck by chuck(fragment)
    onStart?.();

    const decoder = new TextDecoder('utf-8'); //converts bytes to text.
    let buffer = ''; //accumulates partial text until it can be split correctly.
    let firstChunkReceived = false;

    while (true) {
      //Infinite loop that reads the stream until done is true (end of stream).
      const { done, value } = await reader.read(); //value is a Uint8Array with the data.
      if (done) break;

      buffer += decoder.decode(value, { stream: true }); //The chunk is decoded and added to the buffer.

      const lines = buffer.split('\n'); //Then it is divided by lines
      buffer = lines.pop() || ''; //The last line may be incomplete. It will be saved for the next cycle.

      for (const line of lines) {
        //Every line of the stream is checked.
        const lineStream = line.trim();

        if (lineStream.includes('Error:')) {
          //Error sent directly from backend
          await reader.cancel();
          onError?.();
          onLoading?.();
          return;
        }

        if (lineStream.startsWith('event:')) {
          const data = lineStream.slice(6).trim();
          if (data === 'done') {
            //finish connection
            await reader.cancel();
            onComplete?.();
            onLoading?.();
            return;
          }
        }

        if (lineStream.startsWith('data:')) {
          //Only those that begin with "data:"" will be processed::
          const data = lineStream.slice(5).trim(); //remove "data:" and spaces

          if (data === '{"success": true}') {
            //Improve
            //finish connection
            await reader.cancel();
            onComplete?.();
            onLoading?.();
            return;
          }

          if (firstChunkReceived) {
            onLoading?.(); // apagar loader
            firstChunkReceived = false;
          }

          onMessage(data);
          continue;
        }
      }
    }
  } catch (err) {
    //If there is a general error (network, parding, etc.) call onError
    if (onError) {
      onError(err);
      onLoading?.();
    }
  }
}
